import { Button, type ButtonProps } from './Button.tsx'
import { NavigationIcon } from './NavigationIcon.tsx'

interface NavigationButtonProps extends ButtonProps {
	direction: 'left' | 'right'
	classNames?: {
		base?: string
		icon?: string
	}
}

export const NavigationButton = ({
	direction,
	classNames,
	...props
}: NavigationButtonProps) => {
	return (
		<Button
			className={classNames?.base}
			variant="tertiary"
			size="icon"
			{...props}
		>
			<NavigationIcon
				className={classNames?.icon}
				direction={direction}
			/>
		</Button>
	)
}
